<template>
    <section class="container cms-docs-layout gap-4">
        <div v-if="notFound" class="cms-document md:order-2">
            <Alert variant="danger" class="my-8">
                <AlertDescription>{{ $t("ErrorPage.NotFound") }}</AlertDescription>
            </Alert>
        </div>
        <CmsDocument v-else-if="document" :document class="md:order-2">
            <DocsManufacturers v-if="showManufacturerNames" />
            <DocsDistributors v-else-if="showDistributorNames" />
            <DocsCompanyChangeLog v-else-if="showCompanyChangeLog" />
            <DocsRegions v-else-if="showRegionsList" />
            <DocsDssSample v-else-if="showDssSample && dssSampleDocId" :doc-id="dssSampleDocId" />
        </CmsDocument>
        <CmsNavigation :navigation :root class="md:order-1">
            <h3>
                <NuxtLinkLocale to="/docs">{{ $t("StaticSiteStrings.docs_title") }}</NuxtLinkLocale>
            </h3>
            <CmsSearch search-type="docs" :root :title="$t('StaticSiteStrings.docs_placeholder')" />
        </CmsNavigation>
        <CmsHeadings v-if="document" class="md:order-3" :document />
    </section>
</template>
<script setup lang="ts">
const route = useRoute();
const { document, navigation, root, notFound } = await useCmsPage("docs", "/docs/", "navigation.json");

const { redirectUrl } = document.value ?? {};
if (redirectUrl) {
    await navigateTo(redirectUrl, { external: isValidUrl(redirectUrl), replace: true, redirectCode: 301 });
}

const pagePath = Array.isArray(route.params.path)
    ? route.params.path.filter((part) => !!part).join("/")
    : route.params.path;

const showManufacturerNames = computed(() => pagePath === "api/manufacturers-list");
const showDistributorNames = computed(() => pagePath === "api/distributors-list");
const showCompanyChangeLog = computed(() => pagePath === "api/company-change-log");
const showRegionsList = computed(() => pagePath === "participating-distributors/global-functionality");
const showDssSample = computed(() => pagePath?.startsWith("distributor-stock-search/sample-"));
const dssSampleDocId = computed(() => pagePath?.replace("distributor-stock-search/", ""));
</script>
